export const getErrorFromResponse = (error, defaultMessage) => {
   if (error.response && error.response.data) {
      return error.response.data.error || defaultMessage;
   }
   return error.message || defaultMessage || 'An unknown error occurred';
};
